
import "../../style/components/searchbox.scss";
import {Modals} from "../Types/Modals";
import IPlace, {isValidPlace} from "@wikicasa/common/model/Place";
import type Place from "@wikicasa/common/model/Place";
//@ts-ignore
import MapModal from "@vmodals/MapModal.vue";
//@ts-ignore
import {useSearch} from "@wkComposables/useSearch";
import * as Icons from "@wikicasa/common/icons";
//@ts-ignore
import listingTypologyMultiSelect from "@vueEntry/listingTypologyMultiSelect.vue";
//@ts-ignore
import PlaceBox from "./PlaceBox.vue";
import {SearchPlaceType} from "../Types/SearchPlaceTypes";
//@ts-ignore
import FiltersAgencyModal from "@vmodals/FiltersAgencyModal.vue";
import {MultiListingTypology} from "@wikicasa/common/model/MultiListingTypology";
import {PLACE_TYPE} from "@customTypes/PlaceType";
import {getDefaultSearchBean} from "@wikicasa/common/model/RealEstateSearchBean";
//@ts-ignore
import {useSearchBeanPlace} from "@wkComposables/useSearchBeanPlace";
//@ts-ignore
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
//@ts-ignore
import BaseInput from "@vueEntry/UIKitComponents/BaseInput.vue";
import {isSafari} from "@utils/DeviceDetection";
import {CONTRACT} from "@customTypes/ContractEnum";
import {defineComponent} from "vue";
//@ts-ignore
import {redirectToValuation} from "@wkWebSrc/js/valuation/valuationCookie"

enum TABTYPE {
    SALE = "sale-tab",
    RENT = "rent-tab",
    AUCTION = "auction-tab",
    AGENCY = "agency-tab",
    VALUATE = "valuate-tab",
    SELLING = "sell-tab",
    TREND = "trend-tab",
}

import {mapState, mapActions} from "pinia";
import {useSearchBeanStore} from "@store/SearchBeanStore";


export default defineComponent({
    name: "SearchBoxHome",
    components: {
        BaseButton,
        MapModal,
        BaseInput,
        listingTypologyMultiSelect,
        PlaceBox,
        FiltersAgencyModal
    },
    props: {
        expand: {
            type: Boolean,
            default: false
        },
        isHome: {
            type: Boolean,
            default: false
        },
        not_found: {
            type: Boolean,
            default: false
        },
        valuation_tab: {
            type: Boolean,
            default: true
        },
        trend_tab: {
            type: Boolean,
            default: true
        },
        sell_tab: {
            type: Boolean,
            default: true
        }
    },
    emits: ["is-agency-active"],
    setup(){
        const { search } = useSearch()
        const {
            updateSearchBeanBySearchPlace,
            updateSearchBeanByMapPlace,
        } = useSearchBeanPlace()

        return {
            search,
            //useSearchBeanPlace
            updateSearchBeanBySearchPlace,
            updateSearchBeanByMapPlace,
        }
    },
    data() {
        return {
            agencyLabel: "Qualsiasi",
            isValuationLoading: false,
            isSellingLoading: false,
            isSearchLoading: false,
            forceCloseMultiTypology: false,
            forceClosePlace: false,
            modal: null as (Modals | null),
            //default tab selected
            activeTab: TABTYPE.SALE as TABTYPE,
            valuationPlace: null as (IPlace | null),
            place: null as (IPlace | null),
            cityURL: "",
            showMapBtn: false as boolean,
            forceSearch: false,
            agencyFilter: {
                name: "" as string,
                franchiseId: null as number | null,
                uri: "" as string
            },
        }
    },
    created(): void {
        if(window.location.href.includes("affitto-case"))
            this.setActiveTab("rent-tab")
        if(window.location.href.includes("asta-case"))
            this.setActiveTab("auction-tab")
        if(window.location.href.includes("agenzie-immobiliari"))
            this.setAgencyTabActive();
    },
    mounted(): void {
        if (isSafari()) {
            window.onpageshow = (event): void => {
                if (event.persisted) {
                    this.isSearchLoading = true;
                    this.isSearchLoading = false;
                }
            };
        }
    },
    methods: {
        closePlaceDropdown(): void {
            this.forceCloseMultiTypology = false;
            this.forceClosePlace = true;
        },
        closeMultiListingTypology(): void {
            this.forceClosePlace = false;
            if (!this.isAgencyActive) {
                this.forceCloseMultiTypology = true;
                return;
            }
            this.closeAgencyFranchiseList()
        },
        closeAgencyFranchiseList(): void {
            const dropdownMenuAgency = this.$refs.dropdownMenuAgency as HTMLElement
            const dropdownToggleAgency = this.$refs.dropdownToggleAgency as HTMLElement
            if (dropdownMenuAgency?.classList.contains("show"))
                dropdownMenuAgency?.classList.remove("show")
            if (dropdownToggleAgency?.classList.contains("show"))
                dropdownToggleAgency?.classList.remove("show")
        },
        setAgencyTabActive(): void {
            this.setActiveTab("agency-tab");
            this.resetPlaceIfNecessary();
        },
        resetPlaceIfNecessary(): void {
            if (this.searchBean.placeType == PLACE_TYPE.AREA_OF_INTEREST)
                this.setSearchBean(getDefaultSearchBean());
        },
        onLTMSChange(options: MultiListingTypology) {
            this.searchBean.macroTypologyId = options.macroTypologyID;
            this.searchBean.listingTypologyURL = options.url;
            this.searchBean.listingTypologyId = options.listingTypologyId;
            this.searchBean.listingTypologyIdList = options.selectedListingTypologiesIDList;
            this.searchBean.typologyIdList = options.selectedTypologiesIDList;
        },
        openModal(modal: Modals): void {
            this.modal = modal;
        },
        closeModal(): void {
            this.modal = null;
        },
        isActive(tabElement: string): boolean {
            return this.activeTab === tabElement;
        },
        setActiveTab(tabElement: string): void {
            this.activeTab = tabElement;
        },
        handleSearch(): void {
            this.forceSearch = true;
            this.isSearchLoading = true;
            if (this.hasSearchError) {
                this.isSearchLoading = false;
                return;
            }
            this.forceClosePlace = true;
            this.isAgencyActive
                ? this.closeAgencyFranchiseList()
                : this.forceCloseMultiTypology = true;
            this.search(true, this.customListingTypologyURL, this.useContractType, this.agencyFilter.name || this.agencyFilter.franchiseId ? this.agencyFilter : null);
        },
        handleValuation(place: Place, e: Event): void {
            if (!isValidPlace(place)) {
                Icons.removeSpinner(e.currentTarget as HTMLElement);
                return;
            }
            this.valuationPlace = place;
        },
        valuationRedirect(isSelling: boolean): void {
            this.isValuationLoading = true;
            this.forceSearch = true;
            if (this.hasValuationError) {
                this.isValuationLoading = false;
                return;
            }
            this.forceClosePlace = true;
            this.forceCloseMultiTypology = true;
            redirectToValuation(this.valuationPlace, 1, isSelling);
        },
        updateContractType(contractType: TABTYPE): void {
            this.forceSearch = false;
            this.forceCloseMultiTypology = false
            this.forceClosePlace = false
            this.$emit("is-agency-active", this.isAgencyActive)
            switch (contractType) {
                case TABTYPE.SALE:
                    this.updateSearchBean({
                        sale: true,
                        rent: false,
                        contractType: CONTRACT.SALE,
                        auctionType: 0,

                    });
                    break;
                case TABTYPE.RENT:
                    this.updateSearchBean({
                        sale: false,
                        rent: true,
                        contractType: CONTRACT.RENT,
                        auctionType: 0,
                    });
                    break;
                case TABTYPE.AUCTION:
                    this.updateSearchBean({
                        sale: false,
                        rent: false,
                        contractType: CONTRACT.AUCTION,
                        auctionType: 1,
                    });
                    break;
                case TABTYPE.AGENCY:
                    // TODO resettare place se è Area di interesse o locality
                    this.updateSearchBean({
                        sale: false,
                        rent: false,
                        contractType: undefined,
                        auctionType: 0,
                    });
                    break;
                case TABTYPE.VALUATE:
                    this.updateSearchBean({
                        sale: false,
                        rent: false,
                    });
                    this.valuationTypologyId = this.lastValuationTypologyId;
                    break;
                case TABTYPE.SELLING:
                    this.updateSearchBean({
                        sale: false,
                        rent: false,
                    });
                    this.valuationTypologyId = this.lastValuationTypologyId;
                    break;
                case TABTYPE.TREND:
                    break;
                default:
                    this.updateSearchBean({
                        sale: true,
                        rent: false,
                        contractType: CONTRACT.SALE
                    });
            }
        },
        getOptions(key: string) {
            return window["_options"][key];
        },
        getPlaceFromModal(obj: SearchPlaceType): void {
            this.closeModal();
            if (!obj.place)
                return;

            this.place = obj.place;
            this.updateSearchBeanBySearchPlace(obj, false);
        },
        getPlaceFromMapModal(obj: any): void {
            this.closeModal();
            this.previouslyAroundMe = this.aroundMe;
            this.aroundMe = obj.aroundMe;
            this.radius = obj.radius;

            this.updateSearchBeanByMapPlace({
                polygon: obj.polygon,
                polygonForDB: obj.polygonForDB
            });
        },
        saveFilterAgency(agencyFilter: any): void {
            this.agencyFilter = {...agencyFilter};
            this.modal = null;
        },
        selectedGroupAgency(franchise: any): void {
            this.agencyFilter.franchiseId = franchise.id;
            this.agencyFilter.uri = franchise.uri;
            this.agencyLabel = franchise.label;
            this.closeAgencyFranchiseList()
        },
        /*        ...mapMutations(["setSearchBean", "setSearchBeanByKey", "updateSearchBean"]),
        ...mapActions(["updateRESBCounter"])*/
        ...mapActions(useSearchBeanStore, [
            "setSearchBean", "setSearchBeanByKey", "updateSearchBean", "updateRESBCounter"
        ])
    },
    computed: {
        placeTypes(): string {
            return this.isAgencyActive ? "C,P,Z,L,R" : "C,P,Z,L,I,R,A";
        },
        cdn(): string {
            return window["_cdn"];
        },
        labels(): Record<string, string> {
            return window["_labels"];
        },
        //TODO: da controllare in quanto è possibile che non serva più (filtri solo in listato)
        isSearchReady(): boolean {
            return !!(this.searchBean?.cityURL || this.searchBean?.polygonFromMap);
        },
        isValuationReady(): boolean {
            return !!this.valuationPlace?.address
        },
        hasSearchError(): boolean {
            return this.forceSearch && !this.isSearchReady;
        },
        hasValuationError(): boolean {
            return this.forceSearch && !this.valuationPlace?.address;
        },
        listingTypologies(): Array<any> {
            return this.getOptions("listingTypologies");
        },
        isSearchActive(): boolean {
            return this.isActive("sale-tab") || this.isActive("rent-tab") || this.isActive("auction-tab");
        },
        isAgencyActive(): boolean {
            return this.isActive("agency-tab");
        },
        isValuationActive(): boolean {
            return this.isActive("valuation-tab");
        },
        isSellingActive(): boolean {
            return this.isActive("sell-tab");
        },
        isTrendActive(): boolean {
            return this.isActive("trend-tab");
        },
        customListingTypologyURL(): string {
            return this.isAgencyActive ? this.agencyListingTypologyURL :
                this.isTrendActive ? this.trendListingTypologyURL : "";
        },
        useContractType(): boolean {
            return !(this.isAgencyActive || this.isTrendActive);
        },
        agencyListingTypologyURL(): string {
            return this.labels.macroTypology_url_5;
        },
        trendListingTypologyURL(): string {
            return this.labels.trend_url;
        },
        ...mapState(useSearchBeanStore, ["searchBean", "realEstateCounter"])
    },
    watch: {
        activeTab(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.updateContractType(newValue);
            }
        }
    }
})
